import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Renderização visual do boleto (bolepix) na tela — replica o protótipo:
 * header, Valor + Vencimento, Beneficiário, Descrição e a caixa PIX com o QR
 * gerado no cliente (<qrcode>) + código copia-e-cola. Componente 100% visual:
 * o download do PDF e o "copiar" são delegados ao consumidor via eventos.
 *
 * O QR aqui é renderizado client-side (angularx-qrcode), NÃO depende de
 * serviço externo de imagem — esse só é usado na geração do PDF.
 */
@Component({
  selector: 'rsm-boleto-view',
  templateUrl: './boleto-view.component.html',
  styleUrls: ['./boleto-view.component.scss'],
})
export class BoletoViewComponent {
  /** Valor total da cobrança. */
  @Input() amount = 0;

  /** Data de vencimento da cobrança (dateExpire do PIX). */
  @Input() dueDate: string | Date | null = null;

  /** Código PIX copia-e-cola — usado no QR e no texto. */
  @Input() qrCode = '';

  /** Descrição principal da cobrança. */
  @Input() description = 'Crédito de saldo em carteira';

  /** Detalhe/segunda linha da descrição. */
  @Input() descriptionDetail = 'Recarga de créditos para uso na plataforma';

  /** Linha de info do topo (ex.: "EMPRESA | CNPJ | CAMPANHA"). Opcional. */
  @Input() infoLine = '';

  /** Beneficiário (fixo da RSM). */
  @Input() beneficiaryName = 'DMND Sistemas';
  @Input() beneficiaryDoc = '18.144.172/0001-02';

  /** True enquanto o PDF está sendo gerado/baixado. */
  @Input() isDownloading = false;

  // Estado do polling de confirmação (mesma transação do PIX).
  @Input() checking = false;
  @Input() timedOut = false;
  @Input() confirmed = false;
  @Input() confirmedMessage = 'Pagamento confirmado!';
  @Input() checkingMessage =
    'Verificando pagamento... será confirmado automaticamente assim que compensado.';
  @Input() timedOutMessage =
    'Aguardando confirmação do banco. O pagamento é detectado automaticamente assim que compensado.';

  @Output() download = new EventEmitter<void>();
  @Output() copy = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();

  /** So permite baixar o PDF se houver QR code gerado. */
  get canDownload(): boolean {
    return !!this.qrCode && this.qrCode !== '0000';
  }
}
